module.exports = __webpack_public_path__ + "static/media/floor_concrete_systemPlate.890079bb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/floor_concrete_systemPlate.png
 ** module id = 951
 ** module chunks = 0
 **/